import      { defineStore                     } from 'pinia';
import        axios                             from 'axios';
import      { parse                           } from 'lossless-json';
import        useGeneralServices                from '@/core/servicesCoreMainAxios';
import type { IResponseIAuthLogin, IdtoClient } from '@/interfaces/Iauthlogin';
import type { IResponseApi }                    from '@/interfaces/IauthGateway';
import        messages                          from '@/core/composable/useMessages';
import        SettingsAplications               from '@/core/settingsCoreAplications';

const         Permissions = new SettingsAplications();
const                 api = Permissions.endPointMain.secure.name;
const    apiLoginSesion   = Permissions.endPointMain.logins.name;
const       _urlPublic    = Permissions.endPointMain.core.name;
const    { axiosPost,axiosRegisterLogs} = useGeneralServices();
const                data = { "user"          : Permissions.apps.AuthGateway.user,
                              "password"      : Permissions.apps.AuthGateway.password,
                              "consumerKey"   : Permissions.apps.AuthGateway.consumerKey,
                              "consumerSecret": Permissions.apps.AuthGateway.consumerSecret
                            };
const             today = new Date();
const              date = today.toISOString().slice(0,10);
const { notification }  = messages();

export const useAuthorization = defineStore({
    id: 'authorizationStore',
    state: (): IResponseIAuthLogin => ({
        idUsrData      : {},
        statusLogin    : false,
        statusRecovery : false,
        statusProgress : false,
        statusToken    : false,
        authAplication : true,
authAplicattionMessage : "",
        accessTokenApp : "",
        expiredOnApp   : "",
       refreshTokenApp : "",
        statusCodeApp  : 0,
     statusRefreshApp  : false,
                    ip : "" ,
  availablePermissions : [],
      availableBranchs : [],
             alertDash : null,
          alertModules : null,
           alertAction : null,
                 appId : Permissions.apps.AuthGateway.id,
               dtoAuthLoginAccess : {
                    "userId": '0',
                    "appId":'',
                    "moduleId": '',
                    "actionId":'',
                    "descripcion": '',
                    "app": Permissions.apps.AuthGateway.name,
                    "module": 'api/secure/login',
                    "action": 'Access',
                    "record": '0'
        },
        dtoAuthLoginSesions: {
                    "userId": '0',
                    "appId": Permissions.apps.AuthGateway.id,
                    "moduleId": Permissions.modules.logins.id,
                    "actionId":Permissions.actions.create.id,
                    "descripcion": 'Logins-Sesion',
                    "app": Permissions.apps.AuthGateway.name,
                    "module": Permissions.modules.logins.name,
                    "action": Permissions.actions.create.name,
            "record": '0'
        }
    }),
    getters: {
        getStatusLogin    :(state) => state.statusLogin,
        getEmail          :(state) => state.idUsrData.Email,  
        getIdUser         :(state) => state.idUsrData.Id.value,  
        getStatusProgress :(state) => state.statusProgress,
        getIp             :(state) => state.ip,    
        getStatusToken    :(state) => state.statusToken,
        getToken          :(state) => state.accessTokenApp,
        getRefeshToken    :(state) => state.refreshTokenApp,
        getExpiredOn      :(state) => state.expiredOnApp,
        getauthAplication :(state) => state.authAplication,
        getMessage        :(state) => state.authAplicattionMessage,
        getStatusCode     :(state) => state.statusCodeApp,
        getPermissions    :(state) => state.availablePermissions,
        getUsersBranches  :(state) => state.availableBranchs,
        statusAlertDash   :(state) => state.alertDash,
        statusAlertModules:(state) => state.alertModules,
        statusAlertAction :(state) => state.alertAction,
        getIdApp          : (state) => state.appId,
    },

    actions: {
        async setAlertDash(status:boolean) {
            this.alertDash = status;
        },
        
        async setAlertModules(status:boolean) {
            this.alertModules = status;
        },
        
        async setAlertAction(status:boolean) {
            this.alertAction = status;
        },
             
        toggleRecovery (){
            this.statusLogin=false;
        },
        toggleProgress (){
            this.statusProgress= !this.statusProgress;
        },
        setProgress (){
            this.statusProgress= false;
        },
        
        setauthAplication (){
            this.authAplication = false;
        },

        setResponseToken(token:string,refreshToken:string,expiredOn:string){
            this.statusToken = true;
            this.accessTokenApp  = token;
            this.refreshTokenApp = refreshToken;
            this.expiredOnApp    = expiredOn;
        },
        setTokens(){
            this.statusToken      = false;
            this.accessTokenApp   = "";
            this.refreshTokenApp  = "";
            this.expiredOnApp     = "";
            this.statusCodeApp    = 0;
            this.statusRefreshApp = false;
        },
        
        setLogins(){
            this.statusLogin          = false;
            this.idUsrData            = {};
            this.availablePermissions = [];
            this.availableBranchs          = [];
        },

        oneCheckAcctionPermissions(appsId: string | undefined, moduleId: string | undefined, actionName: string) {
            return this.availablePermissions.some(auto => {
            return auto.Permissions?.some(all => {
            return all.App?.Id?.value === appsId &&  all.Module?.Id?.value === moduleId && all.Action?.Name === actionName;
            });
            });
        },
        
        twoCheckAcctionPermissions(appsId: string | undefined, moduleId: string | undefined, actionName: Array<string>) {
             const onePermission = this.availablePermissions.some(auto => {
            return auto.Permissions?.some(all => {
            return all.App?.Id?.value === appsId &&  all.Module?.Id?.value === moduleId && all.Action?.Name === actionName[0];
            });
            });
            
            const twoPermission = this.availablePermissions.some(auto => {
            return auto.Permissions?.some(all => {
            return all.App?.Id?.value === appsId && all.Module?.Id?.value === moduleId && all.Action?.Name === actionName[1];
            });
            });
           
            return onePermission && twoPermission ? true : false;
        },
        
        checkAcctionPermissions(appsId: string | undefined, moduleId: string | undefined, actionName: string[]): boolean {
            if (!appsId || !moduleId || !actionName.length) return false;

            const hasPermission = this.availablePermissions.some(auto =>
                auto.Permissions?.some(all =>
                    (all.App?.Id?.value ?? '') === appsId &&
                    (all.Module?.Id?.value ?? '') === moduleId &&
                    actionName.includes(all.Action?.Name ?? '')
                )
            );

            if (actionName.length === 2 || actionName.length === 3 || actionName.length === 4) {
                const foundActions = new Set<string>();

                this.availablePermissions.forEach(auto => {
                    auto.Permissions?.forEach(all => {
                        const action = all.Action?.Name ?? '';
                        if (
                            (all.App?.Id?.value ?? '') === appsId &&
                            (all.Module?.Id?.value ?? '') === moduleId &&
                            actionName.includes(action)
                        ) {
                            foundActions.add(action);
                        }
                    });
                });

                return foundActions.size === actionName.length; // Retorna true si encuentra todas las acciones
            }

            return hasPermission;
        },


        async auhtAplication(){
            const response = <IResponseApi>await axiosPost(_urlPublic+"/login", data, null);

              if(response.StatusCode == 200){
                this.statusToken     = response.Success;
                this.accessTokenApp  = response.AccessToken;
                this.refreshTokenApp = response.RefreshToken;
                this.expiredOnApp    = response.ExpiresOn;
                this.statusCodeApp   = response.StatusCode;
              }else{
                notification("error", "Aplication Invalid: "+response.StatusCode+": "+response.Message);
                this.setTokens();
              }
        },

        async auhtAplicationRefresh(){
            return <IResponseApi>await axiosPost(_urlPublic+'/refresh-token',{ "accessToken": this.accessTokenApp, "expiresOn": date, "refreshToken": this.refreshTokenApp}, null);               
        },

        async login(dto:{email:string,password:string},dtoClient:IdtoClient){
           const { notification } = messages();

           await this.auhtAplication();

           if(this.statusCodeApp == 200){
            const response = <IResponseApi> await axiosPost(api+"/login", dto, null); 
               
               if (response.Status == 200 && response.StatusCode == 200 && response.Success) {
                    if(!response.Content.ValidEmail || !response.Content.ValidPhoneNumber){
                        notification("info", "verify access credentials [ unverified email / unverified phone]");
                    }else{
                        const parseResponse: any   = parse(response.Request);                        
                        this.idUsrData             = parseResponse.Content;
                        this.availablePermissions  = parseResponse.Content.Roles;
                        this.availableBranchs      = parseResponse.Content.Branches;
                        this.dtoAuthLoginSesions.userId = this.idUsrData.Id.value;
                        dtoClient.UserId = this.idUsrData.Id.value;
                        
                        const registerLoginSesion = await axiosPost(apiLoginSesion, dtoClient, this.dtoAuthLoginSesions);  
                        
                        if (registerLoginSesion.Status === 200 && !registerLoginSesion.Success && registerLoginSesion.StatusCode !== 200) {
                            notification("error", "Login Sesiones Register");   
                        }
                        
                        this.dtoAuthLoginAccess.userId = this.idUsrData.Id.value;
                        this.dtoAuthLoginAccess.descripcion = 'Access Login';
                                                
                        await axiosRegisterLogs(this.dtoAuthLoginAccess);
                        this.statusLogin = true; 
                        notification("success", "Granted Access");                        
                    }
                }else if(response.Status == 200 && (response.StatusCode == 404 || response.StatusCode == 401) ){
                    this.statusRecovery = false;                        
                    this.setTokens();
                    notification("info", "verify access credentials [ "+response.Message+" ]");
                }else{
                    this.statusRecovery = false; 
                    this.setTokens();
                     notification("error",response.Status+"--"+response.Message);
                }            
           }
        },

        async getAdressIp() {

            try {
                await axios("https://api.ipify.org/?format=json").then((response) => {
               this.ip = response.data.ip;
            });    
            } catch (error) {
                notification("error","api.ipify.org");
            }
            
        },

        destroyerSesion(){
            this.authAplication         = true;
            this.authAplicattionMessage = "";
            this.setTokens();
            this.setLogins();
        },

        expulseAplication(msg:string){
            this.authAplication         = false;
            this.authAplicattionMessage = msg;
            this.setTokens();
            this.setLogins();
        }
    },
    persist: true,
})